var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNdr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic_menu_ndrs_32p",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_11",
    "data-name": "Mask Group 11",
    transform: "translate(-730 -1054)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_446",
    "data-name": "Group 446",
    transform: "translate(732.24 1055.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_445",
    "data-name": "Group 445",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3581",
    "data-name": "Path 3581",
    d: "M52.906,71.325a.51.51,0,0,0-.6.4,5.559,5.559,0,0,1-5.462,4.665,5.849,5.849,0,0,1-5.552-4.057h2.383V71.315H39.62v4.057h1.014V73.42a6.869,6.869,0,0,0,6.212,3.98A6.552,6.552,0,0,0,53.3,71.923a.507.507,0,0,0-.4-.6",
    transform: "translate(-26.942 -48.494)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3582",
    "data-name": "Path 3582",
    d: "M53.883,51.251a6.655,6.655,0,0,0-5.959-3.707,6.967,6.967,0,0,0-6.7,4.93.507.507,0,0,0,.974.283,6.024,6.024,0,0,1,5.725-4.2,5.67,5.67,0,0,1,5.239,3.55H50.84v1.014H54.9V49.065H53.883Z",
    transform: "translate(-28.019 -32.33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3583",
    "data-name": "Path 3583",
    d: "M41.712,20.031H50.84a.507.507,0,0,0,0-1.014H41.712a.507.507,0,1,0,0,1.014",
    transform: "translate(-28.019 -12.932)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3584",
    "data-name": "Path 3584",
    d: "M41.712,42.218H50.84a.507.507,0,0,0,0-1.014H41.712a.507.507,0,1,0,0,1.014",
    transform: "translate(-28.019 -28.019)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3585",
    "data-name": "Path 3585",
    d: "M18.519,11.216a.507.507,0,0,0-.715.055l-3.169,3.7L12.7,13.513a.507.507,0,1,0-.608.811l2.318,1.739a.507.507,0,0,0,.689-.076l3.477-4.057a.505.505,0,0,0-.055-.714",
    transform: "translate(-8.083 -7.544)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3586",
    "data-name": "Path 3586",
    d: "M18.519,33.4a.507.507,0,0,0-.715.055l-3.169,3.7L12.7,35.7a.507.507,0,1,0-.608.811l2.318,1.739a.507.507,0,0,0,.689-.076l3.477-4.057a.505.505,0,0,0-.055-.714",
    transform: "translate(-8.083 -22.631)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3587",
    "data-name": "Path 3587",
    d: "M17.805,57.23l-3.169,3.7L12.7,59.472a.507.507,0,0,0-.608.811l2.318,1.739a.507.507,0,0,0,.689-.076l3.477-4.057a.507.507,0,1,0-.77-.659",
    transform: "translate(-8.083 -38.796)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3588",
    "data-name": "Path 3588",
    d: "M21.211,0H6.176A6.182,6.182,0,0,0,0,6.175V21.21a6.182,6.182,0,0,0,6.175,6.175h4.475a.507.507,0,0,0,0-1.014H6.176A5.166,5.166,0,0,1,1.015,21.21V6.175a5.166,5.166,0,0,1,5.161-5.16H21.211a5.166,5.166,0,0,1,5.161,5.16v7.518a.507.507,0,1,0,1.014,0V6.175A6.181,6.181,0,0,0,21.211,0",
    transform: "translate(-0.001 0)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNdr);
export default __webpack_public_path__ + "static/media/NDR.de7b779b051638c878003b89aadf1276.svg";
export { ForwardRef as ReactComponent };